import { createAction } from 'actions/utils'

export const ADD_SINGLE_CONDITION = 'ADD_SINGLE_CONDITION'
export const addSingleCondition = createAction(ADD_SINGLE_CONDITION, [
  'subType',
  'fnId',
  'isSixteenBitCan',
  'isNativeOutput',
  'isOutputBoolean',
])

export const MOVE_SINGLE_CONDITION = 'MOVE_SINGLE_CONDITION'
export const moveSingleCondition = createAction(MOVE_SINGLE_CONDITION, [
  'condition',
  'fnId',
])

export const MOVE_SINGLE_CONDITION_TO_LOGIC_SET =
  'MOVE_SINGLE_CONDITION_TO_LOGIC_SET'
export const moveSingleConditionToLogicSet = createAction(
  MOVE_SINGLE_CONDITION_TO_LOGIC_SET,
  ['condition', 'fnId', 'nextIndex']
)

export const DELETE_SINGLE_CONDITION = 'DELETE_SINGLE_CONDITION'
export const deleteSingleCondition = createAction(DELETE_SINGLE_CONDITION, [
  'uri',
  'fnId',
])

export const SET_CONDITION_FIELD = 'SET_CONDITION_FIELD'
export const setConditionField = createAction(SET_CONDITION_FIELD, [
  'uri',
  'paramName',
  'value',
])

export const RESET_CONDITION = 'RESET_CONDITION'
export const resetCondition = createAction(RESET_CONDITION, ['uri'])

export const RESET_CONDITION_SHOW_HELP = 'RESET_CONDITION_SHOW_HELP'
export const resetConditionShowHelp = createAction(RESET_CONDITION_SHOW_HELP, [
  'uri',
])

export const ADD_SUGGESTED_OUTPUT = 'ADD_SUGGESTED_OUTPUT'
export const addSuggestedOutput = createAction(ADD_SUGGESTED_OUTPUT, [
  'relatedOutputUri',
  'tmpId',
  'fnId',
  'newIndex',
  'uri',
])

export const ADD_SUGGESTED_OUTPUT_NODE = 'ADD_SUGGESTED_OUTPUT_NODE'
export const addSuggestedOutputNode = createAction(ADD_SUGGESTED_OUTPUT_NODE, [
  'output',
  'fnId',
  'tmpId',
])
